/**
 * Status component
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// Library

// Component
import { Button } from '@general';
// Public content
import { Close, Error, Success } from '@public';
import { capitalize } from 'lodash';

// CSS Style for this module
import styles from './status.module.scss';

/**
 * Interface for Status props
 */
interface StatusProps {
	/** Is status visible */
	show: boolean;
	/** Callback when status is going to close */
	onClose: () => void;
	/** Status type, error or success */
	status: 'error' | 'success';
	/** Optional title to be displayed, one with the status name is shown otherwise */
	title?: string;
	/** Text to be displayed in status */
	msg: React.ReactNode;
	/** Optional setting to show close button */
	closable?: boolean;
	/** Large text */
	largeArea?: boolean;
}

/**
 * Status that indicate what's the result of the user's interaction/request
 * @param {StatusProps} Prop
 * @returns  a styled block container with text
 */
export const Status = ({ onClose, title, msg, show, status, closable, largeArea }: StatusProps) => {
	return (
		<>
			<div className={[styles.status, !show && styles['status-hide']].join(' ')}>
				<Button
					ariaLabel="close"
					customStyles={
						closable || closable == undefined
							? styles['status-close']
							: styles['status-close-hidden']
					}
				>
					<Close handleClick={onClose} customStyles={styles['status-close-icon']} />
				</Button>
				<div className={styles[`status-${status}-rect`]} />
				<div className={styles[largeArea ? 'status-container-large' : 'status-container']}>
					{status === 'error' ? (
						<Error customStyles={styles['status-error']} />
					) : (
						<Success customStyles={styles['status-success']} />
					)}
					<div className={styles['status-text']}>
						<p>{title ?? capitalize(status)}</p>
						<p>{msg}</p>
					</div>
				</div>
			</div>
		</>
	);
};
